import { useRequiredContext } from "@redotech/react-util/context";
import { getRedoSuppliesAccountInfo } from "@redotech/redo-fulfillment-common/supplies";
import { TeamContext } from "./team";

const { teamId: REDO_SUPPLIES_TEAM_ID } = getRedoSuppliesAccountInfo();

/**
 * Whether the active team is Redo's own supplies-selling team. Gates the
 * Supplies settings area, which configures what Redo charges every merchant.
 */
export function useIsRedoSuppliesTeam(): boolean {
  const team = useRequiredContext(TeamContext);
  return team._id.toString() === REDO_SUPPLIES_TEAM_ID;
}
